import React from 'react';
import Link from 'next/link';
import { ButtonInfo } from '../../../models';

interface HomeButtonBannerProps {
  buttonsInfo: ButtonInfo[];
}

export default function HomeButtonBanner({
  buttonsInfo,
}: HomeButtonBannerProps) {
  return (
    <div className="mt-7 mb-5 lg:mb-0 gap-5">
      {buttonsInfo?.length === 0 ? (
        <Link href="https://calendly.com/carlos-meit/meit" target="_blank">
          <button
            type="button"
            className="py-2 rounded tracking-wide transition-colors whitespace-nowrap px-10 bg-color-primary-300 text-system-100 lg:w-80 md:w-80 w-full hover:bg-color-primary-200"
          >
            <p className="text-center text-sm lg:text-lg xl:text-lg md:text-base">
              Agenda un demo con nosotros
            </p>
          </button>
        </Link>
      ) : (
        buttonsInfo
          .slice(0, 3) // NOS ASEGURAMOS DE QUE SOLO SE MUESTREN 3 BOTONES
          .map((button: ButtonInfo, index: number) => (
            <Link href={button.action} target="_blank">
              <button
                key={index}
                type="button"
                className="bg-color-primary-300  text-system-100 border-0 lg:w-80 md:w-80 w-full hover:bg-color-primary-200"
              >
                <p className="text-center text-sm lg:text-lg xl:text-lg md:text-base">
                  {button.title}
                </p>
              </button>
            </Link>
          ))
      )}
    </div>
  );
}
